import styled from 'styled-components';

const ContentCard = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  justify-content: center;
  padding: 20px;
  text-align: center;
`;

const ImageBottom = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ImageLeft = styled.div`
  align-items: flex-start;
  border: 1px solid #e5e8ef;
  border-radius: var(--size-border-radius-md);
  display: flex;
  position: relative;
  width: 100%;
`;

const ImageRight = styled.div`
  align-items: flex-start;
  border: 1px solid #ffcf1d;
  border-radius: var(--size-border-radius-md);
  display: flex;
  position: relative;
  width: 100%;
`;

const ImageTop = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const StaticBanners = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ImageTopCard = styled.div`
  background: var(--color-bg-default);
  border-radius: var(--size-border-radius-md);
  max-width: 30%;
  opacity: 0.8;
  position: absolute;
  right: 32px;
  z-index: 2;

  button {
    margin-top: 12px;
  }
`;

const ImageLeftCard = styled.div`
  background: linear-gradient(
    269.83deg,
    rgba(255, 255, 255, 0.6) -40.01%,
    rgba(205, 216, 212, 0.6) 56.48%,
    rgba(183, 202, 196, 0.6) 99.83%
  );
  height: 240px;
  width: 100%;
  z-index: 2;

  button {
    margin-top: 12px;
  }
`;

const ImageRightCard = styled.div`
  background: linear-gradient(270deg, #ffffff -1.69%, #fddb7f 46.73%, #ffdf85 100%);
  height: 240px;
  width: 100%;
  z-index: 2;

  button {
    margin-top: 12px;
  }
`;

export {
  ContentCard,
  ImageBottom,
  ImageLeft,
  ImageLeftCard,
  ImageRight,
  ImageRightCard,
  ImageTop,
  ImageTopCard,
  StaticBanners
};
